import {
  getDetailsTabRoutes,
  getDetailsTabRouteObjects,
  getSelectableResult
} from "../../../utility/route";
import { childOfOrEqual } from "../../../router/functions";

export const licenceAccountsListLDTRoutes = getDetailsTabRoutes(
  "licence_accounts",
  "licence_account_id"
);

export const licencesListLDTRoutes = getDetailsTabRoutes(
  "licences",
  "licence_id"
);




export const getlicenceAccountsDetailsSelectable = getSelectableResult(
  licenceAccountsListLDTRoutes
);
export const getlicenceDetailsSelectable = getSelectableResult(
  licencesListLDTRoutes
);


export const moduleRoutes = [
  licenceAccountsListLDTRoutes,
  licencesListLDTRoutes
 
];

const detailsRoutes = moduleRoutes.map(m => m.names.details);

export const childOfOrEqualDetails = route => {
  return detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
};
